import React from "react";
import classNames from "classnames";

import { COMMUNICATED_VIA } from "../../common/constants";
import Label from "../../common/components/Label";

export const CommunicatedVia2 = (props) => {
    return (
        <div style={Object.assign({}, props.style)} className={classNames("pure-control-group", props.className)}>
            <Label style={props.labelStyle}>How?</Label>
            <select className="x-communicated-via" value={props.value} onChange={props.onChange}>
                <option key={COMMUNICATED_VIA.PHONE}
                        value={COMMUNICATED_VIA.PHONE}
                        data-test-locator={COMMUNICATED_VIA.PHONE}>Phone</option>
                <option key={COMMUNICATED_VIA.EMAIL}
                        value={COMMUNICATED_VIA.EMAIL}
                >Email</option>
                <option key={COMMUNICATED_VIA.IM} value={COMMUNICATED_VIA.IM} >IM</option>
                <option key={COMMUNICATED_VIA.MESSAGE} value={COMMUNICATED_VIA.MESSAGE} >Message</option>
                <option key={COMMUNICATED_VIA.IN_PERSON} value={COMMUNICATED_VIA.IN_PERSON} >In Person</option>
                <option key={COMMUNICATED_VIA.TV} value={COMMUNICATED_VIA.TV} >Broadcast</option>
            </select>
        </div>);
};
CommunicatedVia2.propTypes = {
    value: React.PropTypes.string,
    className: React.PropTypes.arrayOf(React.PropTypes.string),
    labelStyle: React.PropTypes.object,
    onChange: React.PropTypes.func
};

export default CommunicatedVia2;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/CommunicatedVia.js
 **/